/* © CNES */
import { filterSections } from '../../../../../assets/config/filters/Referenciel';
import { SelectButtonItem } from '../../../../../models/SelectButtonItem';
import { CustomAccordion } from '../../../../shared/Accordion/CustomAccordion';
import { FilterSelectButtons } from '../FilterSelectButtons/FilterSelectButtons';

/**
 * Interface for Sensor Mode Condition Props.
 */
interface SensorModeConditionProps {
  sensorModeOptions: SelectButtonItem[] | null;
  handleChange: (e: any, key: string) => void;
}

/**
 * Sensor modes Condition to display other filters depending on Sensor modes selection.
 * @param sensorModeOptions all Sensor modes for selected Missions / Platforms / product types.
 * @param handleChange Function to handle change on Sensor modes selection.
 * @returns SensorModeCondition Element.
 */
export const SensorModeCondition = ({
  sensorModeOptions,
  handleChange,
}: SensorModeConditionProps) => {
  /**
   * set new values of sensor mode button select
   * @param value The Sensor mode to handle.
   */
  const onChangeSensorMode = (value: string | number[]) => {
    handleChange(value, filterSections.sensorMode.param);
  };

  return (
    <div className="sensorModeFilter">
      <CustomAccordion
        title={filterSections.sensorMode.title}
        children={
          sensorModeOptions && sensorModeOptions.length > 0 ? (
            <FilterSelectButtons
              name={filterSections.sensorMode.param}
              options={sensorModeOptions}
              handleChange={onChangeSensorMode}
            />
          ) : (
            <div>Please select a mission first.</div>
          )
        }
      />
    </div>
  );
};
